export function isContainedAnyRolesRequired (rolesRequired, roleToVerify) {
    if (roleToVerify.length === 0 || !rolesRequired) {
        return false
    }

    if (rolesRequired.includes(roleToVerify.toUpperCase())) {
        return true;
    }
    return false;
}